import { render, staticRenderFns } from "./ManageMarket.modal.vue?vue&type=template&id=5aa0b0b0"
import script from "./ManageMarket.modal.vue?vue&type=script&lang=ts"
export * from "./ManageMarket.modal.vue?vue&type=script&lang=ts"
import style0 from "./ManageMarket.modal.vue?vue&type=style&index=0&id=5aa0b0b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports